<div class="container-fluid p-0">
  <app-header></app-header>
  <div class="row m-0 g-0">
    <div class="col-md-3 p-0">
      <app-folders></app-folders>
    </div>
  <div class="col-md-9 container" style="border-top-left-radius: 15px; border-top-right-radius: 15px; overflow: hidden; margin-top: 0 !important; margin-left: -7px;">
      <div class="card" style="height: 1000px">
        <div class="card-body">
          <div
            class="d-flex justify-content-start"
            style="margin-top: 0 !important"
          >
            <button
              type="button"
              class="btn custom-button"
              style="margin-bottom: 10px"
              (click)="goBack()"
            >
              Back
            </button>
          </div>

          <!-- new -->
          <div
            class="new-card"
                         style="border: 2px solid #4A148C; border-radius: 12px; padding: 10px 20px;background-color: #ffffff; box-shadow: 0 4px 12px rgba(103, 58, 183, 0.1);margin-bottom: -15px; font-family: 'Segoe UI', sans-serif; ">
            <div class="card-content">
              <div
                class="row d-flex align-items-center justify-content-between flex-wrap"
                style="gap: 12px; font-size: 15px; color: #333"
              >
                <div class="col-auto" style="min-width: 180px">
                  <strong style="color: #4a148c">Study Code:</strong>
                  {{ studyCode }}
                </div>
                <div class="col-auto" style="min-width: 180px">
                  <strong style="color: #4a148c">Study Name:</strong>
                  {{ studyName }}
                </div>
                <div class="col-auto" style="min-width: 180px">
                  <strong style="color: #4a148c">Subject Name:</strong>
                  {{ subjectName }}
                </div>
                <div class="col-auto" style="min-width: 180px">
                  <strong style="color: #4a148c">Site Location:</strong>
                  {{ siteLocation }}
                </div>
              </div>
            </div>
          </div>

          <!-- Follow up Visit (Every 4th Month) -->
          <div *ngIf="formName === 'follow-up-visit'">
            <div class="card mt-4">
              <div
                class="card-header d-flex justify-content-between align-items-center"
              >
                <h5 class="m-0">Follow up Visit (Every 4th Month)</h5>
                <button type="button" class="btn custom-button">
                  Create Field
                </button>
              </div>
              <div class="card-body scrollable-container">
                <form (ngSubmit)="submitForm()">
                  <div class="form-group" data-label="1. Follow Up Visit No:">
                    <label for="visitNo">1. Follow up Visit No:</label>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isVisitNoDisabled"
                        id="visitNo"
                        class="form-control"
                        [(ngModel)]="formData.visitNo"
                        name="visitNo"
                        required
                        min="0"
                        (input)="validateVisitNo()"
                      />

                      <small class="text-danger" *ngIf="showError"
                        >Follow-up number cannot be negative!</small
                      >
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === '1. Follow Up Visit No:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: -10px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasVisitNoData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasVisitNoData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasVisitNoData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    [ngClass]="{
                                      'btn-disabled': query.isClosed
                                    }"
                                    (click)="
                                      !query.isClosed && confirmCloseQuery(i)
                                    "
                                  >
                                    Close
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                    [disabled]="query.isClosed"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" data-label="2. Date of Visit:">
                    <label for="visitDate">2. Date of Visit:</label>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="date"
                        [disabled]="isDateOfVisitDisabled"
                        id="visitDate"
                        class="form-control"
                        [(ngModel)]="formData.visitDate"
                        name="visitDate"
                        [min]="screeningMinDate"
                        [max]="todayDate"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen && fieldLabel === '2. Date of Visit:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 9px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasVisitDData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasVisitDData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasVisitDData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button
                              type="button"
                              class="add-btn"
                              (click)="addQuery(i)"
                            >
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-end">
                    <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                    <button type="submit" class="btn custom-button">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!-- Vital Signs Form -->
          <div *ngIf="formName === 'follow-up-vital-signs'">
            <div class="card mt-4">
              <div
                class="card-header d-flex justify-content-between align-items-center"
              >
                <h5 class="m-0">Vital Signs</h5>
                <button
                  type="button"
                  class="btn custom-button"
                  (click)="createField()"
                >
                  Create Field
                </button>
              </div>
              <div class="card-body">
                <form (ngSubmit)="submitForm()">
                  <div
                    class="form-group"
                    data-label="1. Was Vital Signs evaluation performed"
                  >
                    <label>1. Was Vital Signs evaluation performed?</label>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <div class="radio-group">
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isVitalSignDisabled"
                            id="vitalYes"
                            name="vitalSigns"
                            value="yes"
                            [(ngModel)]="formData.vitalSigns"
                            required
                          />
                          <label for="vitalYes" class="ml-1">Yes</label>
                        </label>
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isVitalSignDisabled"
                            id="vitalNo"
                            name="vitalSigns"
                            value="no"
                            [(ngModel)]="formData.vitalSigns"
                            required
                          />
                          <label for="vitalNo" class="ml-1">No</label>
                        </label>
                      </div>
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === '1. Was Vital Signs evaluation performed'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 90px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasVitalSignData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasVitalSignData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasVitalSignData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                    <!-- Show the button only when "Yes" is selected -->
                    <div class="mt-3" *ngIf="formData.vitalSigns === 'yes'">
                      <button
                        type="button"
                        class="btn btn-success"
                        (click)="navigateToVitalSigns()"
                      >
                        Add Vital Signs Data
                      </button>
                    </div>
                    <div class="mt-3" *ngIf="formData.vitalSigns === 'no'">
                      <label>Comments:</label>
                      <textarea
                        class="form-control"
                        [(ngModel)]="formData.vitalSignsComments"
                        name="vitalSignsComments"
                      ></textarea>
                    </div>
                  </div>

                  <div class="text-end">
                    <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                    <button type="submit" class="btn custom-button">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!-- Physical and Systemic Examination Form -->
          <div *ngIf="formName === 'follow-up-physical'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Physical and Systemic Examination</h5>
              <button type="button" class="btn custom-button">
                Create Field
              </button>
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="1. Was physical and systematic examination performed"
                >
                  <label
                    >1. Was physical and systematic examination
                    performed?</label
                  >
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isPhysicalExamDisabled"
                          id="physYes"
                          name="physicalExam"
                          value="yes"
                          [(ngModel)]="formData.physicalExam"
                          required
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isPhysicalExamDisabled"
                          id="physNo"
                          name="physicalExam"
                          value="no"
                          [(ngModel)]="formData.physicalExam"
                          required
                        />
                        <span>No</span>
                      </label>
                    </div>
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '1. Was physical and systematic examination performed'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: 190px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasPhysicalExamData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasPhysicalExamData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasPhysicalExamData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3" *ngIf="formData.physicalExam === 'no'">
                    <label>Comments:</label>
                    <textarea
                      class="form-control"
                      [(ngModel)]="formData.physicalExamComments"
                      name="physicalExamComments"
                    ></textarea>
                  </div>
                  <!-- Show the button only when "Yes" is selected -->
                  <div class="mt-3" *ngIf="formData.physicalExam === 'yes'">
                    <button
                      type="button"
                      class="btn btn-success"
                      (click)="navigateToPhysicalSystemic()"
                    >
                      Add Physical and Systemic Examination Data
                    </button>
                  </div>
                </div>

                <div class="text-end">
                  <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Laboratory Investigation Form -->
          <div
            *ngIf="formName === 'follow-up-laboratory-investigation'"
            class="card mt-4"
          >
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Laboratory Investigation</h5>
              <button type="button" class="btn custom-button">
                Create Field
              </button>
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="1. Was Laboratory Investigation performed"
                >
                  <label>1. Was Laboratory Investigation performed?</label>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isLabDisabled"
                          id="labYes"
                          name="labInvestigation"
                          value="yes"
                          [(ngModel)]="formData.labInvestigation"
                          required
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isLabDisabled"
                          id="labNo"
                          name="labInvestigation"
                          value="no"
                          [(ngModel)]="formData.labInvestigation"
                          required
                        />
                        <span>No</span>
                      </label>
                    </div>
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === '1. Was Laboratory Investigation performed'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: 285px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasLabData || userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasLabData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasLabData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3" *ngIf="formData.labInvestigation === 'no'">
                    <label>Comments:</label>
                    <textarea
                      class="form-control"
                      [(ngModel)]="formData.labInvestigationComments"
                      name="labInvestigationComments"
                    ></textarea>
                  </div>
                  <!-- Show the button only when "Yes" is selected -->
                  <div class="mt-3" *ngIf="formData.labInvestigation === 'yes'">
                    <button
                      type="button"
                      class="btn btn-success"
                      (click)="navigateToLaboratory()"
                    >
                      Add Laboratory Investigation Data
                    </button>
                  </div>
                  <div
                    class="form-group mt-4"
                    data-label="2. Date of Sample Collection:"
                    *ngIf="formData.labInvestigation === 'yes'"
                  >
                    <label>2. Date of Sample Collection:</label>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="date"
                        [disabled]="isDateofSampleDisabled"
                        class="form-control"
                        [(ngModel)]="formData.sampleCollectionDate"
                        name="sampleCollectionDate"
                        [min]="screeningMinDate"
                        [max]="todayDate"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === '2. Date of Sample Collection:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 9px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasSampleDData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasSampleDData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasSampleDData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="text-end">
                  <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Pregnancy Declaration Form -->
          <!-- <div *ngIf="formName === 'follow-up-pregnancy-declaration'">
            <div class="card mt-4" style="border: 2px solid #673AB7; border-radius: 8px; padding: 0px; background-color: #fff;">
              <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="m-0">Pregnancy Declaration</h5>
                <button type="button" class="btn custom-button">Create Field</button>
              </div>
              <div *ngIf = "gender !== 'Male'" class="card-body">
                <form (ngSubmit)="submitForm()">
                  <div class="form-group">
                    <label>1. Are you currently pregnant?</label>
                    <select class="form-control"  [(ngModel)]="formData.pregnancyStatus" name="pregnancyStatus" required>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                      <option value="na">N/A</option>
                    </select>
                  </div>

                  <div class="form-group" *ngIf="formData.labInvestigation === 'yes'">
                    <label>2. Date of Sample Collection:</label>
                    <input type="date" class="form-control" [(ngModel)]="formData.sampleCollectionDate" name="sampleCollectionDate" [min]="screeningMinDate"  [max]="todayDate" required>
                  </div>
  
                  <div class="text-end">
                    <button type="button" class="btn custom-button" (click)="goBack()">Back</button> 
                    <button type="submit" class="btn custom-button">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div> -->
          <div
            *ngIf="formName === 'follow-up-pregnancy-declaration'"
            class="card mt-4"
          >
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Urine Pregnancy Test</h5>
              <button type="button" class="btn custom-button">
                Create Field
              </button>
            </div>

            <div *ngIf="gender !== 'Male'" class="card-body">
              <form (ngSubmit)="submitForm()">
                <!-- Date of Last Menstrual Period (LMP) -->
                <div
                  class="form-group"
                  data-label="Date of Last Menstrual Period (LMP)"
                >
                  <label>Date of Last Menstrual Period (LMP)</label>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <input
                      type="date"
                      [disabled]="isLMPDateDisabled"
                      class="form-control"
                      [(ngModel)]="formData.lmpDate"
                      name="lmpDate"
                      [max]="todayDate"
                      required
                    />
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === 'Date of Last Menstrual Period (LMP)'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: 9px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasLMPData || userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasLMPData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasLMPData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Was Urine Pregnancy Test (UPT) done? -->
                <div
                  class="form-group mt-3"
                  data-label="Was Urine Pregnancy Test (UPT) done"
                >
                  <label>Was Urine Pregnancy Test (UPT) done?</label>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <select
                      class="form-control"
                      [disabled]="isUPTDoneDisabled"
                      [(ngModel)]="formData.uptDone"
                      name="uptDone"
                      (change)="handleUptDoneChange()"
                      required
                    >
                      <option value="">Select</option>
                      <option value="YES">Yes</option>
                      <option value="NO">No</option>
                      <option value="NA">Not Applicable</option>
                    </select>
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === 'Was Urine Pregnancy Test (UPT) done'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: 295px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasUPTData || userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasUPTData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasUPTData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- UPT Result - Shown only if UPT Done is YES -->
                  <div
                    class="form-group mt-4"
                    data-label="UPT Result"
                    *ngIf="formData.uptDone === 'YES'"
                  >
                    <label>UPT Result</label>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <select
                        class="form-control"
                        [disabled]="isUPTResultDisabled"
                        [(ngModel)]="formData.uptResult"
                        name="uptResult"
                        (change)="handleUptResultChange()"
                        required
                      >
                        <option value="">Select</option>
                        <option value="Positive">Positive</option>
                        <option value="Negative">Negative</option>
                        <option value="Referred for confirmation">
                          Referred for confirmation
                        </option>
                      </select>
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="isOptionsModalOpen && fieldLabel === 'UPT Result'"
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 197px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasUPTResultData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasUPTResultData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasUPTResultData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="text-end">
                  <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Anthropometric Data Form -->
          <div *ngIf="formName === 'follow-up-anthropometric-data'">
            <div class="card mt-4">
              <div
                class="card-header d-flex justify-content-between align-items-center"
              >
                <h5 class="m-0">Anthropometric Data</h5>
                <button type="button" class="btn custom-button">
                  Create Field
                </button>
              </div>
              <div class="card-body">
                <form (ngSubmit)="validateForm()" #form="ngForm">
                  <!-- Weight Field -->
                  <div class="form-group" data-label="1. Weight (kg):">
                    <label for="weight">1. Weight (kg):</label>

                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="text"
                        id="weight"
                        [disabled]="isWeightDisabled"
                        [(ngModel)]="formData.weight"
                        name="weight"
                        class="form-control"
                        placeholder="000.00 kg"
                        pattern="^\d{3}\.\d{2}$"
                        (input)="calculateBMI()"
                        #weight="ngModel"
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen && fieldLabel === '1. Weight (kg):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 197px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasWeightData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasWeightData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasWeightData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Height Field -->
                  <div class="form-group mt-3" data-label="2. Height (m):">
                    <label for="height">2. Height (m):</label>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="text"
                        id="height"
                        [(ngModel)]="formData.height"
                        [disabled]="isHeightDisabled"
                        name="height"
                        class="form-control"
                        placeholder="00.00 m"
                        pattern="^\d{2}\.\d{2}$"
                        (input)="calculateBMI()"
                        #height="ngModel"
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen && fieldLabel === '2. Height (m):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 98px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasHeightData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasHeightData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasHeightData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Waist Circumference Field -->
                  <div
                    class="form-group mt-3"
                    data-label="3. Waist Circumference (cm):"
                  >
                    <label for="waist"
                      >3. Waist Circumference (cm) (Part of IDRS
                      Assessment):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="text"
                        id="waist"
                        [disabled]="isWaistDisabled"
                        [(ngModel)]="formData.waistCircumference"
                        name="waistCircumference"
                        class="form-control"
                        placeholder="000.00 cm"
                        pattern="^\d{3}\.\d{2}$"
                        #waist="ngModel"
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === '3. Waist Circumference (cm):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasWaistData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasWaistData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasWaistData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="4. Weight-loss from previous visit (kg):"
                  >
                    <label for="weightLossPrevious"
                      >4. Weight-loss from previous visit (kg):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isWeightLossPreviousDisabled"
                        id="weightLossPrevious"
                        [(ngModel)]="formData.weightLossPrevious"
                        name="weightLossPrevious"
                        class="form-control"
                        placeholder="000.00 kg"
                        pattern="^\d{3}\.\d{2}$"
                        #weightLossPrevious
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '4. Weight-loss from previous visit (kg):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: -10px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasWLPreviousData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasWLPreviousData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasWLPreviousData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    [ngClass]="{
                                      'btn-disabled': query.isClosed
                                    }"
                                    (click)="
                                      !query.isClosed && confirmCloseQuery(i)
                                    "
                                  >
                                    Close
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                    [disabled]="query.isClosed"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="5. Weight-loss since baseline visit (kg):"
                  >
                    <label for="weightLossBaseline"
                      >5. Weight-loss since baseline visit (kg):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isWeightLossBaselineDisabled"
                        id="weightLossBaseline"
                        [(ngModel)]="formData.weightLossBaseline"
                        name="weightLossBaseline"
                        class="form-control"
                        placeholder="000.00 kg"
                        pattern="^\d{3}\.\d{2}$"
                        #weightLossBaseline
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '5. Weight-loss since baseline visit (kg):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 98px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasWLBaselineData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasWLBaselineData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasWLBaselineData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="6. Difference in Waist circumference from previous visit (cm):"
                  >
                    <label for="waistDifferencePrevious"
                      >6. Difference in Waist circumference from previous visit
                      (cm):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isWaistDifferencePreviousDisabled"
                        id="waistDifferencePrevious"
                        [(ngModel)]="formData.waistDifferencePrevious"
                        name="waistDifferencePrevious"
                        class="form-control"
                        placeholder="000.00 cm"
                        pattern="^\d{3}\.\d{2}$"
                        #waistDifferencePrevious
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '6. Difference in Waist circumference from previous visit (cm):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 197px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasWCPreviousData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasWCPreviousData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasWCPreviousData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="7. Difference in Waist circumference since baseline visit (cm):"
                  >
                    <label for="waistDifferenceBaseline"
                      >7. Difference in Waist circumference since baseline visit
                      (cm):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isWaistDifferenceBaselineDisabled"
                        id="waistDifferenceBaseline"
                        [(ngModel)]="formData.waistDifferenceBaseline"
                        name="waistDifferenceBaseline"
                        class="form-control"
                        placeholder="000.00 cm"
                        pattern="^\d{3}\.\d{2}$"
                        waistDifferenceBaseline
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '7. Difference in Waist circumference since baseline visit (cm):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 197px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasWCBaselineData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasWCBaselineData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasWCBaselineData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="8. Body Mass Index (BMI):"
                  >
                    <label for="bmi">8. Body Mass Index (BMI):</label>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="text"
                        [disabled]="isBMIDisabled"
                        id="bmi"
                        [(ngModel)]="formData.bmi"
                        name="bmi"
                        class="form-control"
                        placeholder="00.0 BMI"
                        readonly
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === '8. Body Mass Index (BMI):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 197px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasBMIData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasBMIData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasBMIData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="text-end">
                    <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                    <button type="submit" class="btn custom-button">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!-- Study Product Retrieval Form -->
          <div *ngIf="formName === 'follow-up-product-retrieval'">
            <div class="card mt-4">
              <div
                class="card-header d-flex justify-content-between align-items-center"
              >
                <h5 class="m-0">Study Product Retrieval</h5>
                <button
                  type="button"
                  class="btn custom-button"
                  (click)="createField()"
                >
                  Create Field
                </button>
              </div>
              <div class="card-body">
                <form (ngSubmit)="submitForm()">
                  <div
                    class="form-group"
                    data-label="Was the Study Product retrieved from subject as per protocol"
                  >
                    <label
                      >Was the Study Product retrieved from subject as per
                      protocol?</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <div class="radio-group">
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isRetrievedDisabled"
                            id="studyYes"
                            name="productRetrieved"
                            value="yes"
                            [(ngModel)]="formData.productRetrieved"
                            required
                          />
                          <label for="studyYes" class="ml-1">Yes</label>
                        </label>
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isRetrievedDisabled"
                            id="studyNo"
                            name="productRetrieved"
                            value="no"
                            [(ngModel)]="formData.productRetrieved"
                            required
                          />
                          <label for="studyNo" class="ml-1">No</label>
                        </label>
                      </div>
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Was the Study Product retrieved from subject as per protocol'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasRetrievedData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasRetrievedData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasRetrievedData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                    <div
                      class="mt-3"
                      *ngIf="formData.productRetrieved === 'no'"
                    >
                      <label>Comments:</label>
                      <textarea
                        class="form-control"
                        [(ngModel)]="formData.studyComments"
                        name="studyComments"
                      ></textarea>
                    </div>
                  </div>

                  <div class="text-end">
                    <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                    <button type="submit" class="btn custom-button">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!-- Study Product Accountability Form -->
          <div *ngIf="formName === 'follow-up-product-accountability'">
            <div class="card mt-4">
              <div
                class="card-header d-flex justify-content-between align-items-center"
              >
                <h5 class="m-0">Study Product Accountability</h5>
                <button type="button" class="btn custom-button">
                  Create Field
                </button>
              </div>
              <div class="card-body form-container">
                <form (ngSubmit)="validateForm()" #form="ngForm">
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h5 class="m-0">i. Asana Churna herbal drink</h5>
                  </div>
                  <br />
                  <div
                    class="form-group"
                    data-label="Total Number of sachets/boxes dispensed in previous visit (Asana Churna herbal drink):"
                  >
                    <label for="asanaDispensedPrevious"
                      >Total Number of sachets/boxes dispensed in previous
                      visit:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isAsanaDispensedDisabled"
                        id="asanaDispensedPrevious"
                        class="form-control"
                        [(ngModel)]="formData.asanaDispensedPrevious"
                        name="asanaDispensedPrevious"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>

                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Total Number of sachets/boxes dispensed in previous visit (Asana Churna herbal drink):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 98px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasAsanaSachetsData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasAsanaSachetsData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasAsanaSachetsData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Total Study Product quantity dispensed in previous visit (g) (Asana Churna herbal drink):"
                  >
                    <label for="asanaQuantityPrevious"
                      >Total Study Product quantity dispensed in previous visit
                      (g):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isAsanaQuantityDisabled"
                        id="asanaQuantityPrevious"
                        class="form-control"
                        [(ngModel)]="formData.asanaQuantityPrevious"
                        name="asanaQuantityPrevious"
                        placeholder="000g"
                        pattern="^\d{3}$"
                        required
                        #asanaQuantityPrevious="ngModel"
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Total Study Product quantity dispensed in previous visit (g) (Asana Churna herbal drink):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 197px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasAsanaQuantityData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasAsanaQuantityData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasAsanaQuantityData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Total Number of sachets/boxes retrieved in current visit (Asana Churna herbal drink):"
                  >
                    <label for="asanaRetrievedCurrent"
                      >Total Number of sachets/boxes retrieved in current
                      visit:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isAsanaRetrievedDisabled"
                        id="asanaRetrievedCurrent"
                        class="form-control"
                        [(ngModel)]="formData.asanaRetrievedCurrent"
                        name="asanaRetrievedCurrent"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Total Number of sachets/boxes retrieved in current visit (Asana Churna herbal drink):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 197px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasAsanaRetrievedData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasAsanaRetrievedData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasAsanaRetrievedData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h5 class="m-0">ii. Triphala tablet</h5>
                  </div>
                  <br />
                  <div
                    class="form-group"
                    data-label="Total Number of sachets/boxes dispensed in previous visit (Triphala tablet):"
                  >
                    <label for="triphalaDispensedPrevious"
                      >Total Number of sachets/boxes dispensed in previous
                      visit:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isTriphalaDispensedDisabled"
                        id="triphalaDispensedPrevious"
                        class="form-control"
                        [(ngModel)]="formData.triphalaDispensedPrevious"
                        name="triphalaDispensedPrevious"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Total Number of sachets/boxes dispensed in previous visit (Triphala tablet):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaSachetsData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaSachetsData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaSachetsData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Total Study Product quantity dispensed in previous visit (g) (Triphala tablet):"
                  >
                    <label for="triphalaQuantityPrevious"
                      >Total Study Product quantity dispensed in previous visit
                      (g):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isTriphalaQuantityDisabled"
                        id="triphalaQuantityPrevious"
                        class="form-control"
                        [(ngModel)]="formData.triphalaQuantityPrevious"
                        name="triphalaQuantityPrevious"
                        placeholder="000g"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Total Study Product quantity dispensed in previous visit (g) (Triphala tablet):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 9px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaQuantityData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaQuantityData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaQuantityData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Total Number of sachets/boxes retrieved in current visit (Triphala tablet):"
                  >
                    <label for="triphalaRetrievedCurrent"
                      >Total Number of sachets/boxes retrieved in current
                      visit:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isTriphalaRetrievedDisabled"
                        id="triphalaRetrievedCurrent"
                        class="form-control"
                        [(ngModel)]="formData.triphalaRetrievedCurrent"
                        name="triphalaRetrievedCurrent"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Total Number of sachets/boxes retrieved in current visit (Triphala tablet):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaRetrievedData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaRetrievedData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaRetrievedData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h5 class="m-0">iii. Yava Churna</h5>
                  </div>
                  <br />
                  <div
                    class="form-group"
                    data-label="Total Number of sachets/boxes dispensed in previous visit (Yava Churna):"
                  >
                    <label for="yavaDispensedPrevious"
                      >Total Number of sachets/boxes dispensed in previous
                      visit:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isYavaDispensedDisabled"
                        id="yavaDispensedPrevious"
                        class="form-control"
                        [(ngModel)]="formData.yavaDispensedPrevious"
                        name="yavaDispensedPrevious"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Total Number of sachets/boxes dispensed in previous visit (Yava Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 9px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaSachetsData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaSachetsData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaSachetsData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Total Study Product quantity dispensed in previous visit (g) (Yava Churna):"
                  >
                    <label for="yavaQuantityPrevious"
                      >Total Study Product quantity dispensed in previous visit
                      (g):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isYavaQuantityDisabled"
                        id="yavaQuantityPrevious"
                        class="form-control"
                        [(ngModel)]="formData.yavaQuantityPrevious"
                        name="yavaQuantityPrevious"
                        placeholder="000g"
                        pattern="^\d{3}$"
                        required
                        #yavaQuantityPrevious="ngModel"
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Total Study Product quantity dispensed in previous visit (g) (Yava Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 90px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaQuantityData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaQuantityData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaQuantityData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Total Number of sachets/boxes retrieved in current visit (Yava Churna):"
                  >
                    <label for="yavaRetrievedCurrent"
                      >Total Number of sachets/boxes retrieved in current
                      visit:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isYavaRetrievedDisabled"
                        id="yavaRetrievedCurrent"
                        class="form-control"
                        [(ngModel)]="formData.yavaRetrievedCurrent"
                        name="yavaRetrievedCurrent"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Total Number of sachets/boxes retrieved in current visit (Yava Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 190px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaRetrievedData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaRetrievedData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaRetrievedData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-end">
                    <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                    <button type="submit" class="btn custom-button">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!-- Study Product Compliance Form -->
          <div *ngIf="formName === 'follow-up-product-compliance'">
            <div class="card mt-4">
              <div
                class="card-header d-flex justify-content-between align-items-center"
              >
                <h5 class="m-0">Study Product Compliance</h5>
                <button
                  type="button"
                  class="btn custom-button"
                  (click)="createField()"
                >
                  Create Field
                </button>
              </div>
              <div class="card-body form-container">
                <form (ngSubmit)="validateForm()" #form="ngForm">
                  <!-- Asana Churna Section -->
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h5 class="m-0">i. Asana Churna herbal drink</h5>
                  </div>
                  <br />
                  <div
                    class="form-group"
                    data-label="Is the subject compliant with the usage of Study Product as per the protocol (Asana Churna)"
                  >
                    <label
                      >Is the subject compliant with the usage of Study Product
                      as per the protocol?</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <div class="radio-group">
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isStudyComplainceDisabled"
                            id="studycomplainceYes"
                            name="asanaCompliance"
                            value="yes"
                            [(ngModel)]="formData.asanaCompliance"
                            required
                          />
                          <label for="studycomplainceYes" class="ml-1"
                            >Yes</label
                          >
                        </label>
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isStudyComplainceDisabled"
                            id="studycomplainceNo"
                            name="asanaCompliance"
                            value="no"
                            [(ngModel)]="formData.asanaCompliance"
                            required
                          />
                          <label for="studycomplainceNo" class="ml-1">No</label>
                        </label>
                      </div>
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Is the subject compliant with the usage of Study Product as per the protocol (Asana Churna)'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 9px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasAsanaComplianceData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasAsanaComplianceData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasAsanaComplianceData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                    <div class="mt-3" *ngIf="formData.asanaCompliance === 'no'">
                      <label for="comments">Comments:</label>
                      <textarea
                        class="form-control"
                        [(ngModel)]="formData.studyComplianceComments"
                        name="studyComplianceComments"
                      ></textarea>
                    </div>
                  </div>

                  <div
                    class="form-group"
                    data-label="Date of first Study Product consumed (Asana Churna):"
                  >
                    <label for="asanaFirstDate"
                      >Date of first Study Product consumed:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="date"
                        [disabled]="isAsanaFirstDateDisabled"
                        id="asanaFirstDate"
                        class="form-control"
                        [(ngModel)]="formData.asanaFirstDate"
                        name="asanaFirstDate"
                        [min]="screeningMinDate"
                        [max]="todayDate"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Date of first Study Product consumed (Asana Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 9px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasAsanaFDData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasAsanaFDData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasAsanaFDData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Date of last Study Product consumed (Asana Churna):"
                  >
                    <label for="asanaLastDate"
                      >Date of last Study Product consumed:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="date"
                        [disabled]="isAsanaLastDateDisabled"
                        id="asanaLastDate"
                        class="form-control"
                        [(ngModel)]="formData.asanaLastDate"
                        name="asanaLastDate"
                        [min]="screeningMinDate"
                        [max]="todayDate"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Date of last Study Product consumed (Asana Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 9px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasAsanaLDData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasAsanaLDData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasAsanaLDData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Total quantity of Study Product consumed (g) (Asana Churna):"
                  >
                    <label for="asanaConsumed"
                      >Total quantity of Study Product consumed (g):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isAsanaConsumedDisabled"
                        id="asanaConsumed"
                        class="form-control"
                        [(ngModel)]="formData.asanaConsumed"
                        name="asanaConsumed"
                        placeholder="000g"
                        pattern="^\d{3}$"
                        required
                        (input)="calculateCompliance('asana')"
                        #asanaConsumed="ngModel"
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Total quantity of Study Product consumed (g) (Asana Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 9px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasAsanaConsumedData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasAsanaConsumedData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasAsanaConsumedData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Total quantity of Study Product should ideally be consumed (g) (Asana Churna):"
                  >
                    <label for="asanaIdealConsumed"
                      >Total quantity of Study Product should ideally be
                      consumed by subject (g):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isAsanaIdealDisabled"
                        id="asanaIdealConsumed"
                        class="form-control"
                        [(ngModel)]="formData.asanaIdealConsumed"
                        name="asanaIdealConsumed"
                        placeholder="000g"
                        pattern="^\d{3}$"
                        required
                        (input)="calculateCompliance('asana')"
                        #asanaIdealConsumed="ngModel"
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Total quantity of Study Product should ideally be consumed (g) (Asana Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 9px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasAsanaIdealData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasAsanaIdealData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasAsanaIdealData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Total quantity missed (Asana Churna):"
                  >
                    <label for="asanaMissed">Total quantity missed:</label>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isAsanaMissedDisabled"
                        id="asanaMissed"
                        class="form-control"
                        [(ngModel)]="formData.asanaMissed"
                        name="asanaMissed"
                        placeholder="XXX"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === 'Total quantity missed (Asana Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 9px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasAsanaMissedData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasAsanaMissedData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasAsanaMissedData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Compliance (%) (Asana Churna):"
                  >
                    <label for="asanaCompliancePercentage"
                      >Compliance (%):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="text"
                        [disabled]="isAsanaPercentageDisabled"
                        id="asanaCompliancePercentage"
                        class="form-control"
                        [(ngModel)]="formData.asanaCompliancePercentage"
                        name="asanaCompliancePercentage"
                        readonly
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === 'Compliance (%) (Asana Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 9px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasAsanaperData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasAsanaperData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasAsanaperData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Triphala Tablet Section -->
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h5 class="m-0">ii. Triphala tablet</h5>
                  </div>
                  <br />
                  <div
                    class="form-group"
                    data-label="Is the subject compliant with the usage of Study Product as per the protocol (Triphala)"
                  >
                    <label
                      >Is the subject compliant with the usage of Study Product
                      as per the protocol?</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <div class="radio-group">
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isTriphalaComplianceDisabled"
                            id="triphalaComplainceYes"
                            name="triphalaCompliance"
                            value="yes"
                            [(ngModel)]="formData.triphalaCompliance"
                            required
                          />
                          <label for="triphalaComplainceYes" class="ml-1"
                            >Yes</label
                          >
                        </label>
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isTriphalaComplianceDisabled"
                            id="triphalaComplainceNo"
                            name="triphalaCompliance"
                            value="no"
                            [(ngModel)]="formData.triphalaCompliance"
                            required
                          />
                          <label for="triphalaComplainceNo" class="ml-1"
                            >No</label
                          >
                        </label>
                      </div>
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Is the subject compliant with the usage of Study Product as per the protocol (Triphala)'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaComplianceData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaComplianceData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaComplianceData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                    <div
                      class="mt-3"
                      *ngIf="formData.triphalaCompliance === 'no'"
                    >
                      <label for="comments">Comments:</label>
                      <textarea
                        class="form-control"
                        [(ngModel)]="formData.triphalaComplianceComments"
                        name="triphalaComplianceComments"
                      ></textarea>
                    </div>
                  </div>

                  <div
                    class="form-group"
                    data-label="Date of first Study Product consumed (Triphala):"
                  >
                    <label for="triphalaFirstDate"
                      >Date of first Study Product consumed:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="date"
                        [disabled]="isTriphalaFirstDateDisabled"
                        id="triphalaFirstDate"
                        class="form-control"
                        [(ngModel)]="formData.triphalaFirstDate"
                        name="triphalaFirstDate"
                        [min]="screeningMinDate"
                        [max]="todayDate"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Date of first Study Product consumed (Triphala):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaFDData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaFDData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaFDData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Date of last Study Product consumed (Triphala):"
                  >
                    <label for="triphalaLastDate"
                      >Date of last Study Product consumed:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="date"
                        [disabled]="isTriphalaLastDateDisabled"
                        id="triphalaLastDate"
                        class="form-control"
                        [(ngModel)]="formData.triphalaLastDate"
                        name="triphalaLastDate"
                        [min]="screeningMinDate"
                        [max]="todayDate"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Date of last Study Product consumed (Triphala):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaLDData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaLDData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaLDData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Total quantity of Study Product should ideally be consumed (g) (Triphala):"
                  >
                    <label for="triphalaIdealConsumed"
                      >Total quantity of Study Product should ideally be
                      consumed by subject (g):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isTriphalaIdealDisabled"
                        id="triphalaIdealConsumed"
                        class="form-control"
                        [(ngModel)]="formData.triphalaIdealConsumed"
                        name="triphalaIdealConsumed"
                        placeholder="000g"
                        pattern="^\d{3}$"
                        required
                        (input)="calculateCompliance('triphala')"
                        #triphalaIdealConsumed="ngModel"
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Total quantity of Study Product should ideally be consumed (g) (Triphala):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaIdealData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaIdealData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaIdealData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Total quantity missed (Triphala):"
                  >
                    <label for="triphalaMissed">Total quantity missed:</label>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isTriphalaMissedDisabled"
                        id="triphalaMissed"
                        class="form-control"
                        [(ngModel)]="formData.triphalaMissed"
                        name="triphalaMissed"
                        placeholder="XXX"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === 'Total quantity missed (Triphala):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button  type="button" (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaMissedData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaMissedData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaMissedData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Compliance (%) (Triphala):"
                  >
                    <label for="triphalaCompliancePercentage"
                      >Compliance (%):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="text"
                        [disabled]="isTriphalaPercentageDisabled"
                        id="triphalaCompliancePercentage"
                        class="form-control"
                        [(ngModel)]="formData.triphalaCompliancePercentage"
                        name="triphalaCompliancePercentage"
                        readonly
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === 'Compliance (%) (Triphala):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button  type="button" (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaPerData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaPerData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaPerData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Yava Churna Section -->
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h5 class="m-0">iii. Yava Churna</h5>
                  </div>
                  <br />
                  <div
                    class="form-group"
                    data-label="Is the subject compliant with the usage of Study Product as per the protocol (Yava Churna)"
                  >
                    <label
                      >Is the subject compliant with the usage of Study Product
                      as per the protocol?</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <div class="radio-group">
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isYavaComplianceDisabled"
                            id="yavaComplainceYes"
                            name="yavaCompliance"
                            value="yes"
                            [(ngModel)]="formData.yavaCompliance"
                            required
                          />
                          <label for="yavaComplainceYes" class="ml-1"
                            >Yes</label
                          >
                        </label>
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isYavaComplianceDisabled"
                            id="yavaComplainceNo"
                            name="yavaCompliance"
                            value="no"
                            [(ngModel)]="formData.yavaCompliance"
                            required
                          />
                          <label for="yavaComplainceNo" class="ml-1">No</label>
                        </label>
                      </div>
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Is the subject compliant with the usage of Study Product as per the protocol (Yava Churna)'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button"  (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaComplianceData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaComplianceData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaComplianceData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                    <div class="mt-3" *ngIf="formData.yavaCompliance === 'no'">
                      <label for="comments">Comments:</label>
                      <textarea
                        id="comments"
                        class="form-control"
                        [(ngModel)]="formData.yavaComplianceComments"
                        name="yavaComplianceComments"
                      ></textarea>
                    </div>
                  </div>

                  <div
                    class="form-group"
                    data-label="Date of first Study Product consumed (Yava Churna):"
                  >
                    <label for="yavaFirstDate"
                      >Date of first Study Product consumed:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="date"
                        [disabled]="isYavaFirstDateDisabled"
                        id="yavaFirstDate"
                        class="form-control"
                        [(ngModel)]="formData.yavaFirstDate"
                        name="yavaFirstDate"
                        [min]="screeningMinDate"
                        [max]="todayDate"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>

                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Date of first Study Product consumed (Yava Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button  type="button" (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaFDData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaFDData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaFDData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Date of last Study Product consumed (Yava Churna):"
                  >
                    <label for="yavaLastDate"
                      >Date of last Study Product consumed:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="date"
                        [disabled]="isYavaLastDateDisabled"
                        id="yavaLastDate"
                        class="form-control"
                        [(ngModel)]="formData.yavaLastDate"
                        name="yavaLastDate"
                        [min]="screeningMinDate"
                        [max]="todayDate"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Date of last Study Product consumed (Yava Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button  type="button"  (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaLDData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaLDData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaLDData||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Total quantity of Study Product consumed (g) (Yava Churna):"
                  >
                    <label for="yavaConsumed"
                      >Total quantity of Study Product consumed (g):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isYavaConsumedDisabled"
                        id="yavaConsumed"
                        class="form-control"
                        [(ngModel)]="formData.yavaConsumed"
                        name="yavaConsumed"
                        placeholder="000g"
                        pattern="^\d{3}$"
                        required
                        (input)="calculateCompliance('yava')"
                        #yavaConsumed="ngModel"
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Total quantity of Study Product consumed (g) (Yava Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button"  (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaConsumedData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaConsumedData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaConsumedData||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Total quantity of Study Product should ideally be consumed (g) (Yava Churna):"
                  >
                    <label for="yavaIdealConsumed"
                      >Total quantity of Study Product should ideally be
                      consumed by subject (g):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isYavaIdealDisabled"
                        id="yavaIdealConsumed"
                        class="form-control"
                        [(ngModel)]="formData.yavaIdealConsumed"
                        name="yavaIdealConsumed"
                        placeholder="000g"
                        pattern="^\d{3}$"
                        required
                        (input)="calculateCompliance('yava')"
                        #yavaIdealConsumed="ngModel"
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Total quantity of Study Product should ideally be consumed (g) (Yava Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 197px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button"  (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaIdealData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaIdealData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaIdealData||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Total quantity missed (Yava Churna):"
                  >
                    <label for="yavaMissed">Total quantity missed:</label>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isYavaMissedDisabled"
                        id="yavaMissed"
                        class="form-control"
                        [(ngModel)]="formData.yavaMissed"
                        name="yavaMissed"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>

                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === 'Total quantity missed (Yava Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 197px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button  type="button"  (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                   <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaMissedData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaMissedData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaMissedData||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="Compliance (%) (Yava Churna):"
                  >
                    <label for="yavaCompliancePercentage"
                      >Compliance (%):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="text"
                        [disabled]="isYavaPercentageDisabled"
                        id="yavaCompliancePercentage"
                        class="form-control"
                        [(ngModel)]="formData.yavaCompliancePercentage"
                        name="yavaCompliancePercentage"
                        readonly
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === 'Compliance (%) (Yava Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 197px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button  type="button" (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                     <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaPerData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaPerData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaPerData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="text-end">
                    <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                    <button type="submit" class="btn custom-button">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!-- Study Product Dispensing Record Form -->
          <div *ngIf="formName === 'follow-up-product-dispensing-record'">
            <div class="card mt-4">
              <div
                class="card-header d-flex justify-content-between align-items-center"
              >
                <h5 class="m-0">Study Product Dispensing Record</h5>
                <!--<button type="button" class="btn custom-button" (click)="createField()">Create Field</button>-->
              </div>
              <div class="card-body form-container">
                <form (ngSubmit)="validateForm()" #form="ngForm">
                  <div
                    class="form-group"
                    data-label="1. Were all the Study Products dispensed to the subject as per protocol"
                  >
                    <label
                      >Were all the Study Products dispensed to the subject as
                      per protocol?</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <div class="radio-group">
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isDispensedProtocolDisabled"
                            id="dispensedYes"
                            name="dispensedProtocol"
                            value="yes"
                            [(ngModel)]="formData.dispensedProtocol"
                            required
                          />
                          <span>Yes</span>
                        </label>
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isDispensedProtocolDisabled"
                            id="dispensedNo"
                            name="dispensedProtocol"
                            value="no"
                            [(ngModel)]="formData.dispensedProtocol"
                            required
                          />
                          <span>No</span>
                        </label>
                      </div>
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>

                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '1. Were all the Study Products dispensed to the subject as per protocol'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 285px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasDProtocolData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasDProtocolData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasDProtocolData||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                    <div
                      class="mt-3"
                      *ngIf="formData.dispensedProtocol === 'no'"
                    >
                      <label for="comments">Comments:</label>
                      <textarea
                        class="form-control"
                        [(ngModel)]="formData.dispensedProtocolComments"
                        name="dispensedProtocolComments"
                      ></textarea>
                    </div>
                  </div>

                  <div
                    class="form-group"
                    data-label="3. Was the Daily Product Consumption Log given to the subject"
                  >
                    <label
                      >Was the Daily Product Consumption Log given to the
                      subject?</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <div class="radio-group">
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isLogGivenDisabled"
                            id="guideYes"
                            name="logGiven"
                            value="yes"
                            [(ngModel)]="formData.logGiven"
                            required
                          />
                          <span>Yes</span>
                        </label>
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isLogGivenDisabled"
                            id="guideNo"
                            name="logGiven"
                            value="no"
                            [(ngModel)]="formData.logGiven"
                            required
                          />
                          <span>No</span>
                        </label>
                      </div>
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '3. Was the Daily Product Consumption Log given to the subject'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 285px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button"  (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                   <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasLogData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasLogData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasLogData||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                    <div class="mt-3" *ngIf="formData.logGiven === 'no'">
                      <label for="comments">Comments:</label>
                      <textarea
                        id="comments"
                        class="form-control"
                        [(ngModel)]="formData.logGivenComments"
                        name="logGivenComments"
                      ></textarea>
                    </div>
                  </div>

                  <div
                    class="form-group"
                    data-label="5. Date of dispensing of the Study Products:"
                  >
                    <label for="dispensingDate"
                      >Date of dispensing of the Study Products:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="date"
                        [disabled]="isDispensingDateDisabled"
                        id="dispensingDate"
                        class="form-control"
                        [(ngModel)]="formData.dispensingDate"
                        name="dispensingDate"
                        [min]="screeningMinDate"
                        [max]="todayDate"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '5. Date of dispensing of the Study Products:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 285px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button  type="button"  (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasDispensingDateData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasDispensingDateData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasDispensingDateData||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h5 class="m-0">i. Asana Churna herbal drink</h5>
                  </div>
                  <br />
                  <div
                    class="form-group"
                    data-label="6. Total Number of sachets/boxes dispensed (Asana Churna herbal drink):"
                  >
                    <label for="asanaDispensedCurrent"
                      >Total Number of sachets/boxes dispensed in this
                      visit:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isAsanaSachetsDisabled"
                        id="asanaDispensedCurrent"
                        class="form-control"
                        [(ngModel)]="formData.asanaDispensedCurrent"
                        name="asanaDispensedCurrent"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '6. Total Number of sachets/boxes dispensed (Asana Churna herbal drink):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 190px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button  type="button"   (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasAsanaSDData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasAsanaSDData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasAsanaSDData||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="7. Total Study Product quantity dispensed (g) (Asana Churna herbal drink):"
                  >
                    <label for="asanaQuantityCurrent"
                      >Total Study Product quantity dispensed in this visit
                      (g):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isAsanaStudyDisabled"
                        id="asanaQuantityCurrent"
                        class="form-control"
                        [(ngModel)]="formData.asanaQuantityCurrent"
                        name="asanaQuantityCurrent"
                        placeholder="000g"
                        pattern="^\d{3}$"
                        required
                        #asanaQuantityCurrent="ngModel"
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '7. Total Study Product quantity dispensed (g) (Asana Churna herbal drink):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button"  (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasAsanaQData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasAsanaQData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasAsanaQData||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="8. Batch Number (Asana Churna herbal drink):"
                  >
                    <label for="asanaBatch">Batch Number:</label>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isAsanaBatchDisabled"
                        id="asanaBatch"
                        class="form-control"
                        [(ngModel)]="formData.asanaBatch"
                        name="asanaBatch"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '8. Batch Number (Asana Churna herbal drink):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 9px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button  type="button"  (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasAsanaBatchData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasAsanaBatchData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasAsanaBatchData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="9. Date of Expiry (Asana Churna herbal drink):"
                  >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <label for="asanaExpiry">Date of Expiry:</label>
                      <input
                        type="date"
                        [disabled]="isAsanaExpiryDisabled"
                        id="asanaExpiry"
                        class="form-control"
                        [(ngModel)]="formData.asanaExpiry"
                        name="asanaExpiry"
                        [min]="screeningMinDate"
                        [max]="todayDate"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '9. Date of Expiry (Asana Churna herbal drink):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 98px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                     <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasAsanaExpiryData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasAsanaExpiryData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasAsanaExpiryData  ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h5 class="m-0">ii. Triphala tablet</h5>
                  </div>
                  <br />
                  <div
                    class="form-group"
                    data-label="10. Total Number of sachets/boxes dispensed (Triphala tablet):"
                  >
                    <label for="triphalaDispensedCurrent"
                      >Total Number of sachets/boxes dispensed in this
                      visit:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isTriphalaSachetsDisabled"
                        id="triphalaDispensedCurrent"
                        class="form-control"
                        [(ngModel)]="formData.triphalaDispensedCurrent"
                        name="triphalaDispensedCurrent"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '10. Total Number of sachets/boxes dispensed (Triphala tablet):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button"   (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaSDData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaSDData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaSDData  ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="11. Total Study Product quantity dispensed (g) (Triphala tablet):"
                  >
                    <label for="triphalaQuantityCurrent"
                      >Total Study Product quantity dispensed in this visit
                      (g):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isTriphalaStudyDisabled"
                        id="triphalaQuantityCurrent"
                        class="form-control"
                        [(ngModel)]="formData.triphalaQuantityCurrent"
                        name="triphalaQuantityCurrent"
                        placeholder="000g"
                        pattern="^\d{3}$"
                        required
                        #triphalaQuantityCurrent="ngModel"
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '11. Total Study Product quantity dispensed (g) (Triphala tablet):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 9px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button"  (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaQData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaQData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaQData  ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="12. Batch Number (Triphala tablet):"
                  >
                    <label for="triphalaBatch">Batch Number:</label>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isTriphalaBatchDisabled"
                        id="triphalaBatch"
                        class="form-control"
                        [(ngModel)]="formData.triphalaBatch"
                        name="triphalaBatch"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>

                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === '12. Batch Number (Triphala tablet):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 98px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button  type="button" (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaBatchData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaBatchData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaBatchData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="13. Date of Expiry (Triphala tablet):"
                  >
                    <label for="triphalaExpiry">Date of Expiry:</label>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="date"
                        [disabled]="isTriphalaExpiryDisabled"
                        id="triphalaExpiry"
                        class="form-control"
                        [(ngModel)]="formData.triphalaExpiry"
                        name="triphalaExpiry"
                        [min]="screeningMinDate"
                        [max]="todayDate"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === '13. Date of Expiry (Triphala tablet):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 197px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button  type="button"  (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaExpiryData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaExpiryData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaExpiryData||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h5 class="m-0">iii. Yava Churna</h5>
                  </div>
                  <br />
                  <div
                    class="form-group"
                    data-label="14. Total Number of sachets/boxes dispensed (Yava Churna):"
                  >
                    <label for="yavaDispensedCurrent"
                      >Total Number of sachets/boxes dispensed in this
                      visit:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isYavaSachetsDisabled"
                        id="yavaDispensedCurrent"
                        class="form-control"
                        [(ngModel)]="formData.yavaDispensedCurrent"
                        name="yavaDispensedCurrent"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '14. Total Number of sachets/boxes dispensed (Yava Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button  type="button" (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                   <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaSDData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaSDData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaSDData||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="15. Total Study Product quantity dispensed (g) (Yava Churna):"
                  >
                    <label for="yavaQuantityCurrent"
                      >Total Study Product quantity dispensed in this visit
                      (g):</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isYavaStudyDisabled"
                        id="yavaQuantityCurrent"
                        class="form-control"
                        [(ngModel)]="formData.yavaQuantityCurrent"
                        name="yavaQuantityCurrent"
                        placeholder="000g"
                        pattern="^\d{3}$"
                        required
                        #yavaQuantityCurrent="ngModel"
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '15. Total Study Product quantity dispensed (g) (Yava Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button"  (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaQData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaQData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaQData||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="16. Batch Number (Yava Churna):"
                  >
                    <label for="yavaBatch">Batch Number:</label>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isYavaBatchDisabled"
                        id="yavaBatch"
                        class="form-control"
                        [(ngModel)]="formData.yavaBatch"
                        name="yavaBatch"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === '16. Batch Number (Yava Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button"  (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaBatchData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaBatchData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaBatchData||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="17. Date of Expiry (Yava Churna):"
                  >
                    <label for="yavaExpiry">Date of Expiry:</label>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="date"
                        [disabled]="isYavaExpiryDisabled"
                        id="yavaExpiry"
                        class="form-control"
                        [(ngModel)]="formData.yavaExpiry"
                        name="yavaExpiry"
                        [min]="screeningMinDate"
                        [max]="todayDate"
                        required
                      />
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === '17. Date of Expiry (Yava Churna):'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 295px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button"  (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                     <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaExpiryData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaExpiryData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaExpiryData||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-end">
                    <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                    <button type="submit" class="btn custom-button">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!-- Review of Adverse Events and Concomitant Medication Form -->
          <div *ngIf="formName === 'follow-up-adverse-events'">
            <div class="card mt-4">
              <div
                class="card-header d-flex justify-content-between align-items-center"
              >
                <h5 class="m-0">
                  Review of Adverse Events and Concomitant Medication
                </h5>
                <!--<button type="button" class="btn custom-button">Create Field</button>-->
              </div>
              <div class="card-body">
                <form (ngSubmit)="submitForm()">
                  <div
                    class="form-group"
                    data-label="Did the subject experience any adverse event since last visit"
                  >
                    <label
                      >Did the subject experience any adverse event since last
                      visit?</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <div class="radio-group">
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isAdverseDisabled"
                            id="aeYes"
                            name="adverseEvent"
                            value="yes"
                            [(ngModel)]="formData.adverseEvent"
                            required
                          />
                          Yes
                        </label>
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isAdverseDisabled"
                            id="aeNo"
                            name="adverseEvent"
                            value="no"
                            [(ngModel)]="formData.adverseEvent"
                            required
                          />
                          No
                        </label>
                      </div>
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Did the subject experience any adverse event since last visit'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 9px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasAdverse1Data ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasAdverse1Data ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasAdverse1Data ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                    <!-- Show the button only when "Yes" is selected for Adverse Events -->
                    <div class="mt-3" *ngIf="formData.adverseEvent === 'yes'">
                      <button
                        type="button"
                        class="btn btn-success"
                        (click)="navigateToAdverseEvents()"
                      >
                        Add Adverse Event Data
                      </button>
                    </div>
                  </div>

                  <div
                    class="form-group"
                    data-label="Did the subject take any new or change in concomitant medications since last visit"
                  >
                    <label
                      >Did the subject take any new or change in concomitant
                      medications since last visit?</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <div class="radio-group">
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isAdverseDisabled2"
                            id="medYes"
                            name="concomitantMedication"
                            value="yes"
                            [(ngModel)]="formData.concomitantMedication"
                            required
                          />
                          Yes
                        </label>
                        <label class="radio-label">
                          <input
                            type="radio"
                            [disabled]="isAdverseDisabled2"
                            id="medNo"
                            name="concomitantMedication"
                            value="no"
                            [(ngModel)]="formData.concomitantMedication"
                            required
                          />
                          No
                        </label>
                      </div>
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Did the subject take any new or change in concomitant medications since last visit'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: -10px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasAdverse2Data ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasAdverse2Data ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasAdverse2Data ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    [ngClass]="{
                                      'btn-disabled': query.isClosed
                                    }"
                                    (click)="
                                      !query.isClosed && confirmCloseQuery(i)
                                    "
                                  >
                                    Close
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                    [disabled]="query.isClosed"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                    <!-- Show the button only when "Yes" is selected -->
                    <div
                      class="mt-3"
                      *ngIf="formData.concomitantMedication === 'yes'"
                    >
                      <button
                        type="button"
                        class="btn btn-success"
                        (click)="navigateToConcomitantMedication()"
                      >
                        Add Concomitant Data
                      </button>
                    </div>
                  </div>

                  <div class="text-end">
                    <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                    <button type="submit" class="btn custom-button">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
